import { useEffect, useState } from 'react';
import { fetchFileById } from '../api/FilesApi';
export const useFetchFile = (fileId, fetchOnChange = true) => {
  const [file, setFile] = useState();
  const [isFailed, setIsFailed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    if (fileId) {
      setIsFailed(false);
      setIsLoading(true);
      fetchFileById(fileId).then(_file => {
        setFile(_file);
        setIsLoading(false);
      }).catch(err => {
        console.error(err);
        setIsFailed(true);
        setIsLoading(false);
      });
    }
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  fetchOnChange ? [file] : []);
  return {
    file,
    isFailed,
    isLoading
  };
};